/** @deprecated This component is not used in any domain code. Consider removing. */
import { type ForwardedRef, forwardRef } from 'react';
import { Button } from '@/shared/components/ui/Button';
import { Input } from '@/shared/components/ui/input';
import type { FileInputProps } from './FileInput.types';

const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  (
    { name, onChange, handleRemoveFile, disabled = false, required = false, pattern, value },
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const triggerInputClick = () => {
      if (ref && 'current' in ref && ref.current) {
        ref.current.click();
      }
    };

    return (
      <div className="flex items-center gap-2 min-h-[36px] w-full">
        {/* this is for manipulating the input */}
        <input
          type="file"
          ref={ref}
          name={name}
          onChange={onChange}
          disabled={disabled}
          required={required}
          accept={pattern}
          style={{ display: 'none' }}
          className="hidden"
        />

        {/* filename preview */}
        <Input
          className="flex-1 min-w-0 overflow-hidden text-ellipsis whitespace-nowrap inline-block text-white!"
          type="text"
          value={value}
          title={value}
          readOnly
        />

        {/* upload button */}
        <Button
          type="button"
          variant="default"
          size="sm"
          onClick={triggerInputClick}
          className="shrink-0 bg-[#145873] text-white hover:bg-[#1a6c8d]"
        >
          파일 첨부
        </Button>

        {/* remove button */}
        <Button
          type="button"
          variant="destructive"
          size="sm"
          onClick={handleRemoveFile}
          className="shrink-0"
        >
          X
        </Button>
      </div>
    );
  }
);

FileInput.displayName = 'FileInput';
export default FileInput;
